import { render, staticRenderFns } from "./factoryTestMsgDrawer.vue?vue&type=template&id=64ddc280&scoped=true"
import script from "./factoryTestMsgDrawer.vue?vue&type=script&lang=js"
export * from "./factoryTestMsgDrawer.vue?vue&type=script&lang=js"
import style0 from "./factoryTestMsgDrawer.vue?vue&type=style&index=0&id=64ddc280&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ddc280",
  null
  
)

export default component.exports